import React from 'react';
import LumiaComponent from './Lumia';

// import ColorSelector from './ColorSelector';
import { FacebookShareButton } from '@vz/ui/pkg/Social/Facebook/Share';
import { TwitterShareButton } from '@vz/ui/pkg/Social/Twitter/Share';

import S from './LumiaPage.module.css';

export default function Lumia() {
  return (
    <div className={S.root}>
      <h1>Imageless Lumia 800</h1>
      <div className={S.share}>
        <FacebookShareButton />
        <TwitterShareButton
          text={'Imageless Lumia 800 in pure CSS! Awesome creation! '}
          via={'Vasyl_Zubach'}
        />
      </div>

      <div className={S.wrapper}>
        <div className={S.block} style={{ display: 'flex' }}>
          <div className={S.demo}>
            <LumiaComponent isLocked={false} isOn />
          </div>
        </div>
        <div className={S.block}>
          <h2>Description:</h2>
          <p>
            This rendering of Lumia 800 and its icons were made in pure CSS3. No
            images, no base64, no SVG, no canvas, just a lot of CSS3 and a
            little bit of JavaScript.
          </p>

          <p>Viewed best with the latest browsers versions</p>

          <h2>Lumia features (like in a real iPhone):</h2>
          <ul>
            <li>
              <code>lock</code>/<code>unlock</code>, click and swipe locked
              screen from the bottom to the top like in a real phone
            </li>
            <li>
              <code>on</code>/<code>off</code>, click on power button to turn
              `on` or `off`, and on screen to turn `on`
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
